/**
 * JLP Construct & Repair — logo mark (cropped) shown on a light "plate"
 * so the red + grey artwork stays legible on the dark site.
 */
export default function LogoMark({ size = 40, className = "", plate = true }) {
  return (
    <span
      className={`inline-flex items-center justify-center overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        background: plate ? "#f4f2ef" : "transparent",
        borderRadius: 4,
      }}
      aria-label="JLP Construct & Repair"
    >
      <img
        src="/jlp-mark.png"
        alt=""
        draggable={false}
        style={{
          width: "88%",
          height: "88%",
          objectFit: "contain",
        }}
      />
    </span>
  );
}
